import { NavLink, Outlet } from "react-router-dom";

const ADMIN_LINKS = [
  { to: "/admin", label: "Session costs", end: true },
  { to: "/admin/feedback", label: "Feedback inbox", end: false },
];

function AdminSideNav() {
  return (
    <nav className="w-44 shrink-0 border-r border-border-soft px-3 py-6 flex flex-col gap-1">
      {ADMIN_LINKS.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `px-3 py-2 rounded-[10px] text-sm font-medium no-underline transition-colors duration-150 ${
              isActive ? "text-ink bg-surface2" : "text-text-tertiary hover:text-ink"
            }`
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}

export default function AdminLayout() {
  return (
    <div className="flex-1 flex min-h-0">
      <AdminSideNav />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
